import React, { useState } from 'react'
import RechargeBanner from './Components/RechargeBanner'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import RechargeCards from './Components/RechargeCards';
import SearchScreen from './Components/SearchScreen';
import CartSection from './Components/CartSection';

function SellPhysicalRechargeVouchers () {
   
  const [showCart,setShowCart]=useState(false)
  const[showCards,setShowCards]=useState(false)
  const[cartDetails,setCartDetails]=useState([]) 

 


  const getCards = (input, e) => {
    setShowCards(input);
  };
  
  const getShowCart=(input,response)=>{
    setShowCart(input)
    setCartDetails(response)
  }



 
  return (
    <div>
      

      <DashboardLayout>
      <DashboardNavbar />

      {showCart ? (
        <CartSection  details={cartDetails}   showCart={getShowCart}  showCards={ getCards}/>
      ) : (
        <>
          {showCards ? (
            <RechargeCards handleShowCart={getShowCart} />
          ) : (
            <SearchScreen handleCard={getCards} />
          )}
        </>
      )}
      
     

    </DashboardLayout>


    </div>
  )
}

export default SellPhysicalRechargeVouchers